// Lightweight, safe wrapper around the Meta (Facebook) Pixel.
// The base pixel is loaded in public/index.html; this just fires standard events
// defensively so the app never breaks if the pixel is blocked or not yet loaded.

export function trackFb(event, params, options) {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      if (options) window.fbq("track", event, params || {}, options);
      else window.fbq("track", event, params || {});
    }
  } catch (_) {
    /* no-op: analytics must never break the app */
  }
}

// Fire a standard event at most once per key (persisted), to avoid double-counting
// conversions on page refresh / re-mount (e.g. the Stripe success return page).
export function trackFbOnce(key, event, params, options) {
  try {
    if (typeof window === "undefined") return;
    const storeKey = "fb_fired_" + key;
    if (localStorage.getItem(storeKey)) return;
    localStorage.setItem(storeKey, "1");
    trackFb(event, params, options);
  } catch (_) {
    trackFb(event, params, options);
  }
}

// Read the raw `_fbc` (click id) / `_fbp` (browser id) cookies that the Meta Pixel sets itself.
// Sending these to our backend at checkout time lets the server-side Conversions API attribute
// the eventual Purchase event back to the ad/click that drove it — without us hand-rolling any
// fbclid parsing (the Pixel already does that for us).
function readCookie(name) {
  try {
    const match = document.cookie.match("(?:^|; )" + name + "=([^;]*)");
    return match ? decodeURIComponent(match[1]) : null;
  } catch (_) {
    return null;
  }
}

export function getMetaClickCookies() {
  return { fbc: readCookie("_fbc"), fbp: readCookie("_fbp") };
}
